import { render, staticRenderFns } from "./AdminNaehrwerteRezepturDetails.vue?vue&type=template&id=659131cc&"
import script from "./AdminNaehrwerteRezepturDetails.vue?vue&type=script&lang=js&"
export * from "./AdminNaehrwerteRezepturDetails.vue?vue&type=script&lang=js&"
import style0 from "./AdminNaehrwerteRezepturDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports